import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';

import BulkPriceChangeModal from './BulkPriceChangeModal';
import CoinStackIcon from './CoinStackIcon';
import ActionButton from '../ActionButton';

type BulkPriceChangeProps = {
  selectedIds: Set<string>;
};

export const BulkPriceChange = ({ selectedIds }: BulkPriceChangeProps) => {
  const [showModal, setShowModal] = useState(false);
  const menuPermissions = useOfferingMenuPermissionsContext();

  return (
    <>
      <ActionButton
        disabled={!menuPermissions.contentEdit}
        icon={<CoinStackIcon />}
        onClick={() => setShowModal(true)}
        tooltipTitle={<FormattedMessage id="menu.bulkActions.priceChange.changePrice" />}
      />
      {showModal && <BulkPriceChangeModal onClose={() => setShowModal(false)} selectedIds={selectedIds} />}
    </>
  );
};
